import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { TonnageComponent } from './tonnage.component';
import { SiteListModule } from '@components/site-list/site-list.module';
import { MaterialListModule } from '@components/material-list/material-list.module';
import { ShipListModule } from '@components/ship-list/ship-list.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    CompanyListModule,
    MaterialListModule,
    SiteListModule,
    CompanyListModule,
    ShipListModule
  ],
  declarations: [TonnageComponent],
  entryComponents: [TonnageComponent],
})
export class TonnageModule { }
